module.exports = __webpack_public_path__ + "static/media/box-check.7a02864b.svg";